module.exports = __webpack_public_path__ + "static/media/logo_cuc_blanco_horizontal.792523b5.png";